import { render, staticRenderFns } from "./AttendanceSummaries.vue?vue&type=template&id=3b3d87a8"
import script from "./AttendanceSummaries.vue?vue&type=script&lang=js"
export * from "./AttendanceSummaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports